import { APIClient } from "../api";
import { SolicitationFilterV2, SolicitationsLinkedList } from "../../models/SolicitationFilter";
import { SolicitationView } from "../../models/SolicitationView";
import axios, { AxiosAdapter } from 'axios';
export default class SolicitationAttendantService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async GetFilterMultiAdvancedV2(solicitationFilter: SolicitationFilterV2) {

        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        this.cancelToken = axios.CancelToken.source();

        if (solicitationFilter.attendantType == undefined) {
            solicitationFilter.attendantType = "0";
        }

        const url = this.endpoint
            + `/SolicitationAttendant/FilterMultiAdvancedV2?`
     /*01*/ + `userid=${solicitationFilter.userId}`
     /*02*/ + `&idsCustomer=${solicitationFilter.customerId}`
     /*03*/ + `&idsTeam=${solicitationFilter.idTeam}`
     /*04*/ + `&idsAttedent=${solicitationFilter.attendantId}`
     /*05*/ + `&idsRequesters=${solicitationFilter.requesterId}`
     /*06*/ + `&idsStatus=${solicitationFilter.idStatus}`
     /*07*/ + `&searchText=${solicitationFilter.incidentId}`
     /*08*/ + `&IdsGroupService=${solicitationFilter.IdsGroupService}`
     /*09*/ + `&IdFilterField=${solicitationFilter.IdsFilterField}`
     /*10*/ + `&IdsService=${solicitationFilter.IdsService}`
     /*11*/ + `&dataInicio=${solicitationFilter.dataInicio}`
     /*12*/ + `&dataFinal=${solicitationFilter.dataFinal}`
     /*13*/ + `&TipoData=${solicitationFilter.TipoData}`
     /*14*/ + `&Assunto=${solicitationFilter.assunto}`
     /*15*/ + `&AttendantType=${solicitationFilter.attendantType}`
     /*15*/ + `&AproveMassive=${solicitationFilter.AproveMassive}`
     /*16*/ + `&Form=${solicitationFilter.form}`
            ;

        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }

    async GetLinkedSolicitationParent(idSolicitation: any) {
        const url = `${this.endpoint}/SolicitationAttendant/GetLinkedSolicitationParent/${idSolicitation}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetLinkedSolicitation(idSolicitation: number): Promise<SolicitationView[]> {
        const url = this.endpoint + `/SolicitationAttendant/GetLinkedSolicitationView/${idSolicitation}`;

        return (await this.api({
            method: 'get',
            url
        })).data as SolicitationView[];
    }

    async GetSolicitationLinked(id: number) {
        const url = `${this.endpoint}/SolicitationAttendant/Linked/${id}/${2}`;

        return this.api({
            method: "get",
            url
        })
    }
    async SaveSolicitationLinks(array: Array<number>, id: number) {
        const url = `${this.endpoint}/Solicitation/LinkSolicitation`;

        const param = {
            solicitationId: array,
            solicitationProblemId: id
        }

        return this.api({
            method: "post",
            url,
            data: param
        })
    }

    async SelectAttendantFilters(userId: any) {
        const url = `${this.endpoint}/SolicitationAttendant/SelectAttendantFilters/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async DeleteAttendantFilter(solicitationFilterId: number) {
        const url = `${this.endpoint}/SolicitationAttendant/DeleteAttendantFilter/${solicitationFilterId}`;

        return this.api({
            method: 'delete',
            url
        });
    }

    async SaveFilter(solicitationFilter: any) {
        const url = `${this.endpoint}/SolicitationAttendant/SaveFilter`;

        return this.api({
            method: 'post',
            data: solicitationFilter,
            headers: { "Content-Type": "application/json" },
            url
        });
    }

    async UpdateAttendantFilter(solicitationFilter: any) {
        const url = `${this.endpoint}/SolicitationAttendant/UpdateAttendantFilter`;

        return this.api({
            method: 'put',
            data: solicitationFilter,
            headers: { "Content-Type": "application/json" },
            url
        });
    }

    async GetTimeKeep(idSolicitation: number) {
        const url = `${this.endpoint}/SolicitationAttendant/GetTimeKeep`;

        return await this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: idSolicitation
        });
    }
    
    async getSolicitationDetailByIdWithCheckAutorization(request: any) {
        const url = `${this.endpoint}/SolicitationAttendant/GetSolicitationDetailByIdWithCheckAutorization`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: request
        });
    }
}